import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BsPencilSquare, BsTrash } from 'react-icons/bs';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../styles/admin/serviceEditor.css';
import CreateServiceTypeModal from '../Services/CreateServiceTypeModal'; // Asegúrate de ajustar la ruta correctamente

const ServiceTypesEditor = () => {
  const [serviceTypes, setServiceTypes] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedType, setEditedType] = useState({});
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);

  const getServiceTypes = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/services/getServicesTypes`)
      .then(response => {
        setServiceTypes(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  useEffect(() => {
    getServiceTypes();
  }, []);

  const handleEditClick = (index, type) => {
    setEditingIndex(index);
    setEditedType({ ...type });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedType({ ...editedType, [name]: value });
  };

  const handleSaveClick = () => {
    axios.post(`${process.env.REACT_APP_API_URL}/services/updateServiceType`, editedType)
      .then(response => {
        setMessage('¡Los cambios se han guardado correctamente!');
        setTimeout(() => {
          setMessage('');
        }, 4000);
        setEditingIndex(null);
        getServiceTypes();
      })
      .catch(error => {
        console.error("Error updating service type:", error);
      });
  };

  const handleDeleteClick = (id) => {
    if (window.confirm('¿Estás seguro de que deseas borrar este tipo de servicio?')) {
      axios.delete(`${process.env.REACT_APP_API_URL}/services/deleteServiceType/${id}`)
        .then(response => {
          setMessage('¡El tipo de servicio se ha eliminado correctamente!');
          setTimeout(() => {
            setMessage('');
          }, 4000);
          getServiceTypes();
        })
        .catch(error => {
          console.error("Error deleting service type:", error);
        });
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    getServiceTypes();
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">Administrador de Tipos de Servicios</h2>
      {message && <div className="alert alert-success mt-3">{message}</div>}
      <ul className="list-group">
        {serviceTypes.map((type, index) => (
          <li key={type.id} className="list-group-item d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <BsPencilSquare className='edit-button me-2' onClick={() => handleEditClick(index, type)} />
              <BsTrash className='delete-button me-3' onClick={() => handleDeleteClick(type.id)} />
            </div>
            <div className="type-image me-3">
              <img src={type.image_url} alt={type.name} className="img-thumbnail" width="100" />
            </div>
            {editingIndex === index ? (
              <div className="type-info">
                <input
                  type="text"
                  name="name"
                  value={editedType.name}
                  onChange={handleInputChange}
                  className="form-control d-inline w-auto mb-2"
                />
                <input
                  type="text"
                  name="description"
                  value={editedType.description}
                  onChange={handleInputChange}
                  className="form-control d-inline w-auto mb-2"
                />
                <input
                  type="text"
                  name="image_url"
                  value={editedType.image_url}
                  onChange={handleInputChange}
                  className="form-control d-inline w-auto mb-2"
                />
                <input
                  type="text"
                  name="button_content"
                  value={editedType.button_content}
                  onChange={handleInputChange}
                  className="form-control d-inline w-auto mb-2"
                />
                <button className="btn btn-danger me-2" onClick={() => setEditingIndex(null)}>Cancelar</button>
                <button className="btn btn-success" onClick={handleSaveClick}>
                  Guardar
                </button>
              </div>
            ) : (
              <div className="type-info">
                <>Nombre:
                  <strong>{type.name}</strong><br />
                </>
                <>Descripción: <br />
                  {type.description}<br /><br />
                </>
                <>Contenido del botón: <br />
                  <span>{type.button_content}</span>
                </>
              </div>
            )}
          </li>
        ))}
      </ul>
      <Button variant="primary" onClick={handleShowModal}>Crear un nuevo tipo de servicio</Button>
      <CreateServiceTypeModal show={showModal} handleClose={handleCloseModal} />
    </div>
  );
};

export default ServiceTypesEditor;
